import React from 'react';
import { ChromePicker } from 'react-color';

import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'input',
    type: 'text',
};

class FormInputColor extends Abstrap {

    constructor(props) {
        super(props);
        this.toggleColorPicker = this.toggleColorPicker.bind(this);
        this.closeColorPicker = this.closeColorPicker.bind(this);
        this.onColorPickerChange = this.onColorPickerChange.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.state = {
            displayColorPicker: false,
        };
    }

    toggleColorPicker() {
        this.setState((state) => ({
            displayColorPicker: !state.displayColorPicker,
        }));
    }

    closeColorPicker() {
        this.setState({
            displayColorPicker: false,
        });
    }

    onColorPickerChange(color) {
        const { onChange } = this.props;
        if (!onChange) return;
        onChange(color.hex);
    }

    onInputChange(e) {
        const { onChange } = this.props;
        onChange(e.target.value);
    }

    renderColorPicker() {
        const { value } = this.props;
        const { displayColorPicker } = this.state;
        if (!displayColorPicker) return null;
        return (
            <>
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    }}
                    onClick={this.closeColorPicker}
                />
                <div
                    style={{
                        position: 'absolute',
                        top: '42px',
                        zIndex: 3,
                    }}
                >
                    <ChromePicker
                        color={value}
                        onChangeComplete={this.onColorPickerChange}
                    />
                </div>
            </>
        );
    }

    render() {
        const { value } = this.props;
        return (
            <>
                <div
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...this.filterProps(propTypes)}
                    className="c-form__input c-form__input--color"
                    onClick={this.toggleColorPicker}
                >
                    <div
                        style={{
                            backgroundColor: value,
                            height: '20px',
                            width: '20px',
                        }}
                    />
                </div>
                <input
                    type="text"
                    placeholder="#eb66ce"
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...this.filterProps(propTypes)}
                    className="c-form__input"
                    onChange={this.onInputChange}
                />
                {this.renderColorPicker()}
            </>
        );
    }

}

FormInputColor.propTypes = propTypes;

FormInputColor.defaultProps = defaultProps;

export default FormInputColor;
